import { Button } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { FormActions, useUnsavedChangesGuardSafe } from 'components';

import { useManageShop } from './ManageShopContext';

type Props = {
  readOnly?: boolean;
};

export const ManageShopTabActions: React.FC<Props> = ({ readOnly }) => {
  const { t } = useTranslation();
  const { navigateBack } = useManageShop();
  const { confirmIfDirty } = useUnsavedChangesGuardSafe();
  const formik = useFormikContext();

  const handleBack = useCallback(
    () => confirmIfDirty(navigateBack),
    [confirmIfDirty, navigateBack],
  );

  return (
    <FormActions>
      <Button variant="outlined" onClick={handleBack}>
        {t('buttons.to_list')}
      </Button>
      {!readOnly && (
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          onClick={formik.submitForm}
        >
          {t('buttons.save')}
        </Button>
      )}
    </FormActions>
  );
};
